import React from 'react';

import { Returns } from '~/components/ContractDetails/Returns';
import { ContractInfo } from '~/typings/entities/ContractInfo';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractReturnsViewProps = {
  contractId: string;
  // eslint-disable-next-line react/no-unused-prop-types
  contractIds: string[];
  // eslint-disable-next-line react/no-unused-prop-types
  loading: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  contractDetails: any;
  contractInfo: ContractInfo | null;
  onBack: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onContractChange: (id: string) => void;
};

export function ContractReturnsView({ contractId, contractInfo, onBack }: ContractReturnsViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      {contractInfo && <Returns contractId={contractId} contractInfo={contractInfo} />}
    </div>
  );
}
